module.exports = __webpack_public_path__ + "static/media/wB.e0eb761a.svg";